export default __webpack_public_path__ + "static/media/cow.a50c3502.svg";